<script setup>
import { defineEmits, defineProps } from "vue";
import ButtonWithSpinner from "@/components/forms/SharedComponents/ButtonWithSpinner.vue";

defineEmits(["update:modelValue", "buttonClicked"]);

const props = defineProps({
  vuelidateField: {
    type: Object,
    default: () => {},
  },
  modelValue: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "text",
  },
  id: {
    type: String,
    default: "",
  },
  showErrors: {
    type: Boolean,
    default: false,
  },
  disableButton: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  buttonText: {
    type: String,
    default: "APPLY",
  },
});
</script>

<template>
  <div>
    <label :for="id" class="block text-sm font-medium text-indigo-base">
      <span class="font-medium flex justify-between mb-1">
        {{ label }}
      </span>
      <div class="relative flex flex-wrap items-stretch">
        <input
          :id="props.id"
          :value="props.modelValue"
          :data-cy="props.id + 'Text'"
          :type="props.type"
          class="relative flex-auto outline-none border-0 p-4 ring-1 ring-inset focus:ring-2 focus:ring-inset"
          :class="
            props.vuelidateField.$error
              ? 'ring-error-900 focus:ring-error-900'
              : 'ring-indigo-base focus:ring-indigo-base'
          "
          :placeholder="props.placeholder"
          @input="$emit('update:modelValue', $event.target.value)"
          @blur="props.vuelidateField?.$touch"
        />
        
        <!-- For further customization see example: https://vuejs.org/guide/components/slots.html#fallback-content -->
        <slot>
          <ButtonWithSpinner
            :id="props.id + 'button'"
            :ref="props.id + 'button'"
            data-cy="applyPromoButton"
            type="submit"
            variant="secondary"
            :grey-disabled-class="true"
            :disabled="props.disableButton"
            :prop-loading="props.isLoading"
            :custom-class="'z-[2] inline-block'"
            @click="$emit('buttonClicked')"
          >
            <div class="flex items-center justify-center">
              <span class="pr-3">
                {{ props.buttonText }}
              </span>
            </div>
          </ButtonWithSpinner>
        </slot>
      </div>
    </label>
    <template v-if="showErrors">
      <p
        v-for="error of props.vuelidateField?.$errors"
        :key="error.$uid"
        class="error text-error-900 text-sm"
      >
        {{ error.$message }}
      </p>
    </template>
    <slot name="help-content"></slot>
  </div>
</template>
